/**
 * Created by sxp23 on 1/16/2018.
 */
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component'
import { HelpComponent } from './help-page/help.component'
import { WaterSystemsComponent } from './water-systems/water-systems.component'
import { WaterMapsComponent} from './water-maps/water-maps.component'

const routes:Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'help-page', component: HelpComponent },
  { path: 'waterSystems', component:WaterSystemsComponent},
  { path: 'waterMaps', component:WaterMapsComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
